
import './App.css';
import ScrollToTop from 'react-router-scroll-top'
import Topbar from './components/Topbar/Topbar';
import Burger from './components/Burger/Burger';
import Menu from './components/Menu/Menu';
import Menuscroll from './components/Menuscroll/Menuscroll';
import React, { useState, useRef} from 'react';
import { useOnClickOutside } from './hooks';
import HomeBg from './components/HomeBg/HomeBg';

import { HashRouter as Router, Route, Switch} from 'react-router-dom';

import asyncComponent from './components/AsyncComponent/AsyncComponent';
import styled from 'styled-components';

const Mnl= styled.div`
  margin-top:68px;
  margin-left:170px;
  @media (max-width: 768px) {
  margin-left:0px
  }
`;




const Home = asyncComponent(() =>
    import('./components/Home/Home').then(module => module.default)
)

const Oceans = asyncComponent(() =>
    import('./components/Oceans/Oceans').then(module => module.default)
)

const Ocean_Aquaticlife = asyncComponent(() =>
    import('./components/Ocean_Aquaticlife/Ocean_Aquaticlife').then(module => module.default)
)

const Ocean_Warming = asyncComponent(() =>
    import('./components/Ocean_Warming/Ocean_Warming').then(module => module.default)
)

const Ocean_Overfishing = asyncComponent(() =>
    import('./components/Ocean_Overfishing/Ocean_Overfishing').then(module => module.default)
)

const Ocean_SeaLevel = asyncComponent(() =>
    import('./components/Ocean_SeaLevel/Ocean_SeaLevel').then(module => module.default)
)

const Ocean_Acidification = asyncComponent(() =>
    import('./components/Ocean_Acidification/Ocean_Acidification').then(module => module.default)
)

const Ocean_Hypoxia = asyncComponent(() =>
    import('./components/Ocean_Hypoxia/Ocean_Hypoxia').then(module => module.default)
)

const Ocean_Plasticpollution = asyncComponent(() =>
    import('./components/Ocean_Plasticpollution/Ocean_Plasticpollution').then(module => module.default)
)

const Ocean_Lionfish = asyncComponent(() =>
    import('./components/Ocean_Lionfish/Ocean_Lionfish').then(module => module.default)
)

const Ocean_Coral = asyncComponent(() =>
    import('./components/Ocean_Coral/Ocean_Coral').then(module => module.default)
)

const Ocean_Seaturtle = asyncComponent(() =>
    import('./components/Ocean_Seaturtle/Ocean_Seaturtle').then(module => module.default)
)

const Ocean_Bivalves = asyncComponent(() =>
    import('./components/Ocean_Bivalves/Ocean_Bivalves').then(module => module.default)
)

const Ocean_Lobster = asyncComponent(() =>
    import('./components/Ocean_Lobster/Ocean_Lobster').then(module => module.default)
)

const Ocean_Flatworm = asyncComponent(() =>
    import('./components/Ocean_Flatworm/Ocean_Flatworm').then(module => module.default)
)

const Ocean_Invasivespecies = asyncComponent(() =>
    import('./components/Ocean_Invasivespecies/Ocean_Invasivespecies').then(module => module.default)
)

const Ocean_Phytoplankton = asyncComponent(() =>
    import('./components/Ocean_Phytoplankton/Ocean_Phytoplankton').then(module => module.default)
)

const Ocean_Zooplankton = asyncComponent(() =>
    import('./components/Ocean_Zooplankton/Ocean_Zooplankton').then(module => module.default)
)

const Ocean_Lanternfish = asyncComponent(() =>
    import('./components/Ocean_Lanternfish/Ocean_Lanternfish').then(module => module.default)
)

const Ocean_Crabs = asyncComponent(() =>
    import('./components/Ocean_Crabs/Ocean_Crabs').then(module => module.default)
)

const Ocean_Jellyfish = asyncComponent(() =>
    import('./components/Ocean_Jellyfish/Ocean_Jellyfish').then(module => module.default)
)

const Ocean_Juvenile = asyncComponent(() =>
    import('./components/Ocean_Juvenile/Ocean_Juvenile').then(module => module.default)
)

const Ocean_Seagrass = asyncComponent(() =>
    import('./components/Ocean_Seagrass/Ocean_Seagrass').then(module => module.default)
)

const Ocean_Kelp = asyncComponent(() =>
    import('./components/Ocean_Kelp/Ocean_Kelp').then(module => module.default)
)

const Ocean_Urchins = asyncComponent(() =>
    import('./components/Ocean_Urchins/Ocean_Urchins').then(module => module.default)
)

const Ocean_Krill = asyncComponent(() =>
    import('./components/Ocean_Krill/Ocean_Krill').then(module => module.default)
)

const Ocean_Sharks = asyncComponent(() =>
    import('./components/Ocean_Sharks/Ocean_Sharks').then(module => module.default)
)

const Ocean_Albacore = asyncComponent(() =>
    import('./components/Ocean_Albacore/Ocean_Albacore').then(module => module.default)
)

const Ocean_Seaotters = asyncComponent(() =>
    import('./components/Ocean_Seaotters/Ocean_Seaotters').then(module => module.default)
)

const Land = asyncComponent(() =>
    import('./components/Land/Land').then(module => module.default)
)

const Land_Population = asyncComponent(() =>
    import('./components/Land_Population/Land_Population').then(module => module.default)
)

const Land_Florafauna = asyncComponent(() =>
    import('./components/Land_Florafauna/Land_Florafauna').then(module => module.default)
)

const Land_Agriculture = asyncComponent(() =>
    import('./components/Land_Agriculture/Land_Agriculture').then(module => module.default)
)

const Land_Arcticicemin = asyncComponent(() =>
    import('./components/Land_Arcticicemin/Land_Arcticicemin').then(module => module.default)
)

const Land_Deforestation = asyncComponent(() =>
    import('./components/Land_Deforestation/Land_Deforestation').then(module => module.default)
)

const Land_Forestfires = asyncComponent(() =>
    import('./components/Land_Forestfires/Land_Forestfires').then(module => module.default)
)

const Land_Temperaturerise = asyncComponent(() =>
    import('./components/Land_Temperaturerise/Land_Temperaturerise').then(module => module.default)
)

const Land_Cleanwater = asyncComponent(() =>
    import('./components/Land_Cleanwater/Land_Cleanwater').then(module => module.default)
)

const Atmosphere = asyncComponent(() =>
    import('./components/Atmosphere/Atmosphere').then(module => module.default)
)

const Atmosphere_Composition = asyncComponent(() =>
    import('./components/Atmosphere_Composition/Atmosphere_Composition').then(module => module.default)
)

const Atmosphere_Naturalthreats = asyncComponent(() =>
    import('./components/Atmosphere_Naturalthreats/Atmosphere_Naturalthreats').then(module => module.default)
)

const Atmosphere_CO2 = asyncComponent(() =>
    import('./components/Atmosphere_CO2/Atmosphere_CO2').then(module => module.default)
)

const Atmosphere_Hurricanes = asyncComponent(() =>
    import('./components/Atmosphere_Hurricanes/Atmosphere_Hurricanes').then(module => module.default)
)

const NearSpace = asyncComponent(() =>
    import('./components/NearSpace/NearSpace').then(module => module.default)
)

const NearSpace_Agencies = asyncComponent(() =>
    import('./components/NearSpace_Agencies/NearSpace_Agencies').then(module => module.default)
)

const TakeAction = asyncComponent(() =>
    import('./components/TakeAction/TakeAction').then(module => module.default)
)

const TakeAction_Recipes = asyncComponent(() =>
    import('./components/TakeAction_Recipes/TakeAction_Recipes').then(module => module.default)
)

const TakeAction_Verifyregistration = asyncComponent(() =>
    import('./components/TakeAction_Verifyregistration/TakeAction_Verifyregistration').then(module => module.default)
)

const TakeAction_Register = asyncComponent(() =>
    import('./components/TakeAction_Register/TakeAction_Register').then(module => module.default)
)

function App (props){
  
const [open, setOpen] = useState(false);

//const location= useLocation();

//React.useEffect(() => {
//        props.history.listen(() => {
//            setOpen(false);
//        });
//    });



const node = useRef();
useOnClickOutside(node, () => setOpen(false));

    return(
      
      <Router>
      <ScrollToTop>
        <body> 
        <Menuscroll/>
        
         

          
          <HomeBg/>
          <Mnl>

          <Switch>
              <Route path= "/" component={Home} exact />
              <Route path= "/Oceans" component ={Oceans} />
              <Route path= "/Oceans_Aquatic-life" component ={Ocean_Aquaticlife}/>
              <Route path= "/Oceans_Invasive-species" component={Ocean_Invasivespecies}/>
              <Route path= "/Oceans_Overfishing" component ={Ocean_Overfishing}/>
              <Route path= "/Oceans_Warming" component ={Ocean_Warming}/>
              <Route path= "/Oceans_Sea-Level" component={Ocean_SeaLevel}/>
              <Route path= "/Oceans_Acidification" component={Ocean_Acidification}/>
              <Route path= "/Oceans_Hypoxia" component={Ocean_Hypoxia}/>
              <Route path= "/Oceans_Plastic-pollution" component={Ocean_Plasticpollution}/>
              <Route path= "/Oceans_Lionfish" component={Ocean_Lionfish}/>
              <Route path= "/Oceans_Coral-reefs" component={Ocean_Coral}/>
              <Route path= "/Oceans_Sea-turtle" component={Ocean_Seaturtle}/>
              <Route path= "/Oceans_Bivalves" component={Ocean_Bivalves}/>
              <Route path= "/Oceans_Lobster" component={Ocean_Lobster}/>
              <Route path= "/Oceans_Flatworm" component={Ocean_Flatworm}/>
              <Route path= "/Oceans_Phytoplankton" component={Ocean_Phytoplankton}/>
              <Route path= "/Oceans_Zooplankton" component={Ocean_Zooplankton}/>
              <Route path= "/Oceans_Lanternfish" component={Ocean_Lanternfish}/>
              <Route path= "/Oceans_Crabs" component={Ocean_Crabs}/>
              <Route path= "/Oceans_Jellyfish" component={Ocean_Jellyfish}/>
              <Route path= "/Oceans_Juvenile" component={Ocean_Juvenile}/>
              <Route path= "/Oceans_Seagrass" component={Ocean_Seagrass}/>
              <Route path= "/Oceans_Kelp" component={Ocean_Kelp}/>
              <Route path= "/Oceans_Urchins" component={Ocean_Urchins}/>
              <Route path= "/Oceans_Krill" component={Ocean_Krill}/>
              <Route path= "/Oceans_Sharks" component={Ocean_Sharks}/>
              <Route path= "/Oceans_Albacore" component={Ocean_Albacore}/>
              <Route path= "/Oceans_Sea-otters" component={Ocean_Seaotters}/>

              <Route path= "/Land" component= {Land}/>
              <Route path= "/Land_Population" component={Land_Population}/>
              <Route path= "/Land_Agriculture" component={Land_Agriculture}/>
              <Route path= "/Land_Arctic-ice-minimum" component={Land_Arcticicemin}/>
              <Route path= "/Land_Flora-fauna" component={Land_Florafauna}/>
              <Route path= "/Land_Deforestation" component={Land_Deforestation}/> 
              <Route path= "/Land_Forestfires" component={Land_Forestfires}/> 
              <Route path= "/Land_Temperature-rise" component={Land_Temperaturerise}/> 
              <Route path= "/Land_Clean-water" component={Land_Cleanwater}/> 

              <Route path= "/Atmosphere" component={Atmosphere}/>  
              <Route path= "/Atmosphere_Composition" component={Atmosphere_Composition}/>
              <Route path= "/Atmosphere_Natural-threats" component={Atmosphere_Naturalthreats}/> 
              <Route path= "/Atmosphere_CO2" component={Atmosphere_CO2}/> 
              <Route path= "/Atmosphere_Hurricanes" component={Atmosphere_Hurricanes}/> 

              <Route path= "/Near-Space" component={NearSpace}/>   
              <Route path= "/Near-Space_Agencies" component={NearSpace_Agencies}/> 

              <Route path= "/Take-Action" component={TakeAction}/>  

              <Route path= "/Take-Action_Recipes" component={TakeAction_Recipes}/>
              <Route path= "/Take-Action_Register" component={TakeAction_Register}/>
              <Route path= "/Take-Action_Verify-registration" component={TakeAction_Verifyregistration}/>  
              

          
          </Switch>

          </Mnl>
        </body>
        </ScrollToTop>
      </Router>
      
      );

  
}



export default App;





